class ReorderButton extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('.button--reorder');
        this.error = this.querySelector('.global-message');
        this.errorCopy = this.querySelector('.global-message__copy');
        this.hasSpinner = document.querySelectorAll('.global-loading').length > 0;
        this.spinner = document.querySelector('.global-loading');

        this.button.addEventListener('click', this.reorderButtonClick.bind(this));
    }

    closeDrawers() {
        this.drawers = document.querySelectorAll('.drawer');
        this.drawers.forEach((drawer) => {
            drawer.classList.remove(...['animate', 'active']);
        });
    }

    reorder() {
        const cart = document.querySelector('cart-drawer');
        const singleValue = this.button.getAttribute('data-item');
        const isSingle = singleValue ? true : false;

        if (this.hasSpinner) {
            this.spinner.classList.remove('hidden');
        }

        if (!this.button.getAttribute('data-id')) {
            console.error(window.cartStrings.error);
            this.spinner.classList.add('hidden');
            this.renderError(window.cartStrings.error);
            return;
        }

        const orderID = this.button.getAttribute('data-id');
        const itemsToAdd = isSingle
            ? [window.customerVariables.orders[orderID].line_items[singleValue]]
            : window.customerVariables.orders[orderID].line_items;

        const data = {
            items: itemsToAdd,
        };

        if (cart) {
            data['sections'] = cart.getSectionsToRender().map((section) => section.id);
            data['sections_url'] = window.location.pathname;
            cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.message != 'Cart Error') {
                    this.closeDrawers();
                    localStorage.setItem('hideRepeatPurchase', 'true');
                    sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase, {
                        action: 'Added',
                        context: 'Order Added',
                    });
                    if (!cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }
                    this.hideError();
                    cart.renderContents(response);
                } else {
                    this.renderError(response);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                if (this.hasSpinner) {
                    this.spinner.classList.add('hidden');
                }
            });
    }

    hideError() {
        this.error.classList.remove('global-message--active');
    }

    renderError(response) {
        this.errorCopy.textContent = response.description;
        this.error.classList.add('global-message--active');
    }

    reorderButtonClick(event) {
        event.preventDefault();
        this.reorder();
    }
}

customElements.define('reorder-button', ReorderButton);
